function getWeekdayString(date, { weekday = 'long' }) {
  return weekday === null ? '' : date.toLocaleDateString('da-DK', { weekday })
}

function getDateAndMonthString(date, { day = 'numeric', month = 'short' }) {
  return day === null && month === null ? '' : date.toLocaleDateString('da-DK', { day, month })
}

function getTimeString(date, { hour = '2-digit', minute = '2-digit' }) {
  if (hour === null && minute === null) {
    return ''
  }
  const str = date.toLocaleDateString('da-DK', { hour, minute })

  return str.substr(str.lastIndexOf(' ') + 1, str.length).replace('.', ':')
}

export function getDateRelativity(date) {
  const now = new Date()
  const isSameMonthAndYear =
    now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth()
  const nowDate = now.getDate()
  const thenDate = date.getDate()

  return {
    isYesterday: isSameMonthAndYear && thenDate === nowDate - 1,
    isToday: isSameMonthAndYear && thenDate === nowDate,
    isTomorrow: isSameMonthAndYear && thenDate === nowDate + 1
  }
}

export function getDateString(date, options) {
  options = {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  }
  const { isToday, isTomorrow, isYesterday } = getDateRelativity(date)
  const weekday = getWeekdayString(date, options)
  const today = isToday ? 'i dag' : ''
  const tomorrow = isTomorrow ? 'i morgen' : ''
  const yesterday = isYesterday ? 'i går' : ''
  const relativity = today || tomorrow || yesterday
  const relativityPart = relativity && weekday ? `${relativity}, ` : `${relativity} `
  const dateAndMonth = getDateAndMonthString(date, options)
  const dateAndMonthPart = dateAndMonth ? `d. ${dateAndMonth}` : ''
  const time = getTimeString(date, options)

  return `${relativityPart}${weekday} ${dateAndMonthPart} kl. ${time}`
}
